// extracted by mini-css-extract-plugin
export default {"body":"MainView_body__aD3D4","sticky":"MainView_sticky__skgc2"};